import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import useRestoreDisapprovalReason from "@babackapp/private-api-client/client/use-restore-disapproval-reason";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { Card, CardContent } from "@babackapp/ui/components/card";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@babackapp/ui/components/collapsible";
import { Archive, ChevronRight, RotateCcw } from "lucide-react";

export function ArchivedDisapprovalReasonList() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const { mutate: restore, isPending } = useRestoreDisapprovalReason(shop);

  const archived = shop.disapprovalReasons.filter((reason) => reason.archivedAt);
  if (archived.length === 0) return null;

  return (
    <Card>
      <CardContent className="py-6">
        <Collapsible className="group/archived">
          <CollapsibleTrigger className="flex w-full items-center gap-2 text-sm font-medium text-muted-foreground">
            <ChevronRight className="size-4 transition-transform group-data-[state=open]/archived:rotate-90" />
            {t("settings.disapprovalReasons.archived.title", {
              count: archived.length,
            })}
          </CollapsibleTrigger>
          <CollapsibleContent className="mt-2 flex flex-col">
            {archived.map((reason) => (
              <div
                key={reason.id}
                className="flex items-center justify-between gap-4 border-b border-border py-3 last:border-b-0"
              >
                <div className="flex items-center gap-3">
                  <Archive className="size-4 text-muted-foreground" />
                  <p className="text-sm text-muted-foreground">{reason.label}</p>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  disabled={isPending}
                  onClick={() => restore(reason.id)}
                >
                  <RotateCcw className="size-4" />
                  {t("settings.disapprovalReasons.actions.restore")}
                </Button>
              </div>
            ))}
          </CollapsibleContent>
        </Collapsible>
      </CardContent>
    </Card>
  );
}
